import { render, staticRenderFns } from "./common.vue?vue&type=template&id=368628b4&scoped=true"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"
import style0 from "./common.vue?vue&type=style&index=0&id=368628b4&prod&lang=less&scoped=true"
import style1 from "./common.vue?vue&type=style&index=1&id=368628b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368628b4",
  null
  
)

export default component.exports